/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { ListOfMyCalendarAssignmentDto } from './listOfMyCalendarAssignmentDto.schema';

export const MyCalendarDto = zod.object({
  "id": zod.string().uuid().optional(),
  "monthId": zod.number().optional(),
  "monthName": zod.string().optional(),
  "year": zod.number().optional(),
  "coordinatorName": zod.string().optional(),
  "areaId": zod.number().optional(),
  "areaName": zod.string().optional(),
  "myCalendarAssignments": zod.lazy(() => ListOfMyCalendarAssignmentDto).optional()
});

export type MyCalendarDto = zod.input<typeof MyCalendarDto>;
export type MyCalendarDtoOutput = zod.output<typeof MyCalendarDto>;
